import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { decodeToken } from "react-jwt";
import { clearWebviewSessionFlag } from "src/auth/isEmbedded";
import { readPersistedToken, writePersistedToken, clearPersistedToken } from "src/auth/persistedToken";
import { persistedModules, persistedTheme } from "../persistedClientData";

type UserTokenPayload = {
  Email: string;
  Name: string;
  PhoneNumber: string;
  UserId: string;
  UserIdentifier: string;
  aud: string;
  exp: number;
  iat: number;
  iss: string;
  nbf: number;
  role: string;
  userName: string;
}

interface AuthState {
  user: UserTokenPayload | null;
  token: string | null;
  tenantId:string | null;
  isIntegrated: boolean;
  isTokenExpired: boolean;
}

const persistedToken = readPersistedToken();
const persistedUser = persistedToken ? (decodeToken(persistedToken) as UserTokenPayload) : null;

const initialState: AuthState = {
  user: persistedUser,
  token: persistedToken,
  tenantId: persistedUser?.aud ?? null,
  isIntegrated: false,
  isTokenExpired: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    login: (state, action) => {
      const userData = decodeToken(action?.payload) as UserTokenPayload;
      state.user = userData;
      state.token = action?.payload;
      state.tenantId = userData?.aud;
      writePersistedToken(action?.payload);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.tenantId = null;
      state.isTokenExpired = false;
      clearWebviewSessionFlag();
      clearPersistedToken();
      persistedTheme.clear();
      persistedModules.clear();
    },
    setIntegrated: (state, action: PayloadAction<boolean>) => {
      state.isIntegrated = action.payload;
    },
    setTokenExpired: (state, action: PayloadAction<boolean>) => {
      state.isTokenExpired = action.payload;
    },
  },
});

export const { login, logout, setIntegrated, setTokenExpired } = authSlice.actions;
export const accessTokenSelector = (state: any) => state.token;
export default authSlice.reducer;
